import { render, staticRenderFns } from "./ConfigCourse7.vue?vue&type=template&id=d4c1214a&scoped=true&"
import script from "./ConfigCourse7.vue?vue&type=script&lang=js&"
export * from "./ConfigCourse7.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCourse7.vue?vue&type=style&index=0&id=d4c1214a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c1214a",
  null
  
)

export default component.exports